import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const waybillRequests = '/merchant/waybill'
const merchantResource = '/merchant'
const defaultPagination = 10

export default {
  getWaybillRequestList(pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${waybillRequests}?paginate=${pagination}&page=${pageNumber}`)
  },
  sendWaybillRequestReport(payload) {
    return Repository.post(`${waybillRequests}`, payload)
  },
  getWaybillRequestListNoPagination(filterQuery) {
    return Repository.get(`${waybillRequests}?${filterQuery}&noPagination`)
  },
  getMerchantBusinessDetails() {
    return OperationRepository.get(`${merchantResource}/setting`)
  },
}
